import styled from 'styled-components';

const setFilling = ({ isActive, isPreview }) => {
  if (isActive) {
    return '#EE3524';
  }

  if (isPreview) {
    return '#e0aea9';
  }

  return '#C7C7C7';
};

export const StarStyled = styled.button`
  all: unset;
  svg {
    width: 1rem;
    margin: 0.15rem;
    fill: ${setFilling};
  }
`;

export const RatingStyled = styled.div`
  display: flex;
  align-items: center;
`;
